import React from 'react';
import delay from 'mn-utils/delay';
import noop from 'mn-utils/noop';
import {
  apiV2WithdrawGet
} from '../../../../api/merchant/withdraw';
import withState from '../../../../utils/withState';
import WrapperWithLoading from '../../../dumb/WrapperWithLoading/B';

import WithdrawalHeader from './components/WithdrawalHeader';
import WithdrawalDetailsFiat from './components/WithdrawalDetailsFiat';
import WithdrawalDetailsStablecoin from './components/WithdrawalDetailsStablecoin';
import WithdrawalReference from './components/WithdrawalReference';
import WithdrawalTransactionsList from './components/WithdrawalTransactionsList';


module.exports = withState((setState, self) => {
  let _id;
  let _cancel = noop;

  function update() {
    _cancel();
    _cancel = delay(() => {
      setState({
        loading: true,
      });
      _cancel = apiV2WithdrawGet({
        id: _id,
      }).finally((error, response) => {
        setState({
          data: response || {},
          loading: false,
        });
      }).cancel;
    });
  }

  return (state, props) => {
    const params = props.params || {};
    const {type, id} = params;
    const data = state.data || {};
    const description = data.description;
    const payments = data.payments || [];

    _id === id || update(_id = id);

    const DetailsComponent = type === 'fiat'
      ? WithdrawalDetailsFiat
      : WithdrawalDetailsStablecoin

    return (
      <WrapperWithLoading
        className={props.className}
        loading={state.loading}
      >
        <WithdrawalHeader id={id} payments={payments} assetCode={data.fiat_code || data.sc_code} />
        <DetailsComponent data={data} />
        {description && (
          <WithdrawalReference description={description} />
        )}
        {!!payments.length && (
          <div className="mt45">
            <WithdrawalTransactionsList id={id} items={payments} fiatCode={data.fiat_code} />
          </div>
        )}
      </WrapperWithLoading>
    );
  };
});
